import BaseApi from './BaseApi'
import {exception} from '../../util/decorators'

export default class NewsApi extends BaseApi {
  @exception('获取消息列表失败')
  getPage (params) {
    return this.httpJsonp('/announce/lists', params)
  }

  @exception('获取消息内容失败')
  getDetail (params) {
    return this.httpJsonp('/announce/index', params)
  }
}



// WEBPACK FOOTER //
// ./src/service/api/NewsApi.js